import React, { useState, useEffect } from 'react';
import { Select, Button, Card, Row, Col, Input, message } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import { getMasterComponentData, saveWorkflow } from '../../../services/workFlowService';
import config from '../../common/config';
const DOMAIN_PATH = "/wf";

const { Option } = Select;

const WorkflowEditor = () => {
    const [workflowData, setWorkflowData] = useState(config.workflowJson);
    const [debugComponent, setDebugComponent] = useState(config.debugComponentJson);
    const [workflowName, setWorkflowName] = useState('');
    const [components, setComponents] = useState([]);
    const [selectedComponent, setSelectedComponent] = useState('');
    const [workflowSteps, setWorkflowSteps] = useState([]);

    // Calculate vertical position for each step
    const calculatePosition = (index) => {
        const triggerPos = -251.20000076293945;
        const savePos = 192.79999923706055;
        const totalSteps = workflowSteps.length + 3; // +3 for trigger, debug, and save

        if (index === 0) return triggerPos;
        if (index === totalSteps - 1) return savePos;

        // Calculate position between trigger and save
        const availableSpace = savePos - triggerPos;
        const step = availableSpace / (totalSteps - 1);
        return triggerPos + step * index;
    };

    function getDataFromDiagramJson(diagram) {
        if (!diagram) {
            alert("Invalid diagram data");
            return;
        }

        let jsonData = [];
        let nodesMap = new Map();

        // Store nodes in a map for quick lookup
        diagram.nodeDataArray.forEach(node => {
            nodesMap.set(node.key, node);
        });

        diagram.nodeDataArray.forEach(node => {
            let [x, y] = node.loc.split(" ").map(Number);
            let nodeData = {
                WorkFlowCompId: node.flowStepId,
                ComponentId: node.compId,
                ComponentLocation: `${x}/${y}`,
                Name: node.name,
                DisplayName: node.displayName,
                ImagePath: node.source,
                ComponentPicturePath: "",
                PreviousCompId: 0,
                OutputProperty: node.data ? JSON.stringify(node.data) : "",
                Lines: []
            };

            // Find links where this node is the "from" node
            diagram.linkDataArray.forEach(link => {
                if (link.from === node.key) {
                    let nextNode = nodesMap.get(link.to);
                    let linkData = {
                        WorkFlowStepId: node.flowStepId,
                        NextCompId: nextNode ? nextNode.flowStepId : 0,
                        Status: link.label || "",
                        LocationLine: "",
                        NextWorkFlowId: 0
                    };

                    // Handle special link cases
                    if (link.label && link.label.includes("|")) {
                        let parts = link.label.split("|");
                        if (parts[1].toUpperCase().includes("SAMECOMPONENT")) {
                            linkData.NextCompId = node.flowStepId;
                        } else {
                            linkData.NextWorkFlowId = parseInt(parts[1]) || 0;
                            linkData.NextCompId = nextNode ? nextNode.flowStepId : 0;
                        }
                    }
                    nodeData.Lines.push({ Line: linkData });
                }
            });

            // Find links where this node is the "to" node to determine PreviousCompId
            diagram.linkDataArray.forEach(link => {
                if (link.to === node.key) {
                    let prevNode = nodesMap.get(link.from);
                    if (prevNode) {
                        nodeData.PreviousCompId = prevNode.flowStepId;
                    }
                }
            });

            jsonData.push(nodeData);
        });

        return jsonData;
    }

    // const updateFlowJsonData = () => {
    //     // Create updated nodeDataArray
    //     const updatedNodeDataArray = [
    //         // Keep the trigger - make a deep copy to avoid reference issues
    //         { ...workflowData.nodeDataArray.find(node => node.name === "Trigger") }
    //     ];

    //     // Add debug component as the first step after trigger
    //     const debugPos = calculatePosition(1);
    //     updatedNodeDataArray.push({
    //         "category": "Comp",
    //         "loc": `-383.80000001192093 ${debugPos}`,
    //         "compId": debugComponent.compId,
    //         "masterComponentkey": debugComponent.masterComponentkey,
    //         "key": debugComponent.key,
    //         "name": debugComponent.name,
    //         "displayName": debugComponent.displayName,
    //         "source": debugComponent.source,
    //         "view": debugComponent.view,
    //         "data": debugComponent.data,
    //         "categoryname": debugComponent.categoryname,
    //         "categoryId": debugComponent.categoryId,
    //         "parent": debugComponent.parent,
    //         "selectable": false,
    //         "cursor": "default",
    //         "leftArray": [{ "portId": "left0" }, { "portId": "left1" }, { "portId": "left2" }, { "portId": "left3" }],
    //         "topArray": [{ "portId": "top0" }, { "portId": "top1" }, { "portId": "top2" }, { "portId": "top3" }],
    //         "bottomArray": [{ "portId": "bottom0" }, { "portId": "bottom1" }, { "portId": "bottom2" }, { "portId": "bottom3" }],
    //         "rightArray": [{ "portId": "right0" }, { "portId": "right1" }, { "portId": "right2" }, { "portId": "right3" }],
    //         "flowStepId": 2
    //     });

    //     // Add middle steps
    //     workflowSteps.forEach((step, index) => {
    //         const component = components.find(comp => comp.componentName === step.componentName);

    //         // Skip if component not found
    //         if (!component) {
    //             message.error(`Component data found: ${step.componentId}`);
    //             return;
    //         }

    //         updatedNodeDataArray.push({
    //             "category": "Comp",
    //             "loc": `-383.80000001192093 ${calculatePosition(index + 2)}`, // +2 because of trigger and debug
    //             "compId": component.componentId,
    //             "masterComponentkey": component.componentName,
    //             "key": component.componentId,
    //             "name": component.componentName,
    //             "displayName": component.displayName,
    //             "source": DOMAIN_PATH + component.componentIcon,
    //             "view": component.componentRoute,
    //             "data": component.config,
    //             "categoryname": component.categoryName,
    //             "categoryId": component.categoryId,
    //             "parent": component.categoryId,
    //             "selectable": false,
    //             "cursor": "default",
    //             "leftArray": [{ "portId": "left0" }, { "portId": "left1" }, { "portId": "left2" }, { "portId": "left3" }],
    //             "topArray": [{ "portId": "top0" }, { "portId": "top1" }, { "portId": "top2" }, { "portId": "top3" }],
    //             "bottomArray": [{ "portId": "bottom0" }, { "portId": "bottom1" }, { "portId": "bottom2" }, { "portId": "bottom3" }],
    //             "rightArray": [{ "portId": "right0" }, { "portId": "right1" }, { "portId": "right2" }, { "portId": "right3" }],
    //             "flowStepId": index + 4
    //         });
    //     });

    //     // Add the save step - make a deep copy to avoid reference issues
    //     updatedNodeDataArray.push({
    //         ...workflowData.nodeDataArray.find(node => node.name === "Save")
    //     });

    //     // Create updated linkDataArray
    //     const updatedLinkDataArray = [];

    //     // First link from Trigger to Debug component
    //     updatedLinkDataArray.push({
    //         "from": updatedNodeDataArray[0].key,
    //         "to": updatedNodeDataArray[1].key,
    //         "fromPort": "bottom1",
    //         "toPort": "top1",
    //         "text": "Output",
    //         "label": "Output",
    //         "points": [
    //             -393.30000001192093, calculatePosition(0) + 49,
    //             -393.30000001192093, calculatePosition(0) + 59,
    //             -393.30000001192093, calculatePosition(1) - 54,
    //             -392.30000001192093, calculatePosition(1) - 54,
    //             -392.30000001192093, calculatePosition(1) - 54,
    //             -392.30000001192093, calculatePosition(1) - 44
    //         ],
    //         "link-highlight-color": "transparent"
    //     });

    //     // Links between components
    //     for (let i = 1; i < updatedNodeDataArray.length - 1; i++) {
    //         const fromNode = updatedNodeDataArray[i];
    //         const toNode = updatedNodeDataArray[i + 1];

    //         // Parse data to get line text if possible
    //         let lineText = "Success";

    //         //debugger; // Remove this line in production
    //         //Default line text for Trigger component
    //         if (fromNode.name === "Trigger") {
    //             lineText = "Output";
    //         }

    //         if (fromNode.data) {
    //             try {
    //                 const dataObj = typeof fromNode.data === 'string' ? JSON.parse(fromNode.data) : fromNode.data;
    //                 if (dataObj?.loadJson?.configLines?.lines?.length > 0) {
    //                     lineText = dataObj.loadJson.configLines.lines[0].lineText || "Success";
    //                 }
    //             } catch (error) {
    //                 // Use default "Success" if parsing fails
    //                 console.log('Error parsing component data:', error);
    //             }
    //         }

    //         updatedLinkDataArray.push({
    //             "from": fromNode.key,
    //             "to": toNode.key,
    //             "fromPort": "bottom0",
    //             "toPort": "top1",
    //             "text": lineText,
    //             "label": lineText,
    //             "points": [
    //                 -409.30000001192093, calculatePosition(i) + 50,
    //                 -409.30000001192093, calculatePosition(i) + 60,
    //                 -409.30000001192093, (calculatePosition(i) + calculatePosition(i + 1)) / 2,
    //                 -394.30000001192093, (calculatePosition(i) + calculatePosition(i + 1)) / 2,
    //                 -394.30000001192093, calculatePosition(i + 1) - 17,
    //                 -394.30000001192093, calculatePosition(i + 1) - 7
    //             ],
    //             "link-highlight-color": "transparent"
    //         });
    //     }

    //     // Update the workflow data
    //     setWorkflowData({
    //         ...workflowData,
    //         nodeDataArray: updatedNodeDataArray,
    //         linkDataArray: updatedLinkDataArray
    //     });
    // }

    useEffect(() => {
        // Fetch categories and components from the server
        const fetchAllComponents = async () => {
            try {
                const response = await getMasterComponentData();
                if (!response) {
                    message.error('Failed to fetch components');
                    return;
                }
                const processData = JSON.parse(response.component);
                setComponents(processData);

                const debugComp = processData.find(comp => comp.componentName === config.COMPONENT_NAME.DEBUG);
                //console.log("debugComp:", debugComp);
                if (debugComp) {
                    setDebugComponent(
                        //[...debugComponent,
                        {
                            compId: debugComp.componentId,
                            masterComponentkey: debugComp.componentName,
                            key: debugComp.componentId,
                            name: debugComp.componentName,
                            displayName: debugComp.displayName,
                            source: DOMAIN_PATH + debugComp.componentIcon,
                            view: debugComp.componentRoute,
                            data: debugComp.config,
                            categoryname: debugComp.categoryName,
                            categoryId: debugComp.categoryId,
                            parent: debugComp.categoryId,
                        }
                        //    ]
                    )
                }

            } catch (error) {
                message.error('Failed to fetch components');
            }
        };
        fetchAllComponents();
    }, []);

    // Update the workflow when steps change
    useEffect(() => {
        //updateFlowJsonData();

        // Create updated nodeDataArray
        const updatedNodeDataArray = [
            // Keep the trigger - make a deep copy to avoid reference issues
            { ...workflowData.nodeDataArray.find(node => node.name === "Trigger") }
        ];

        // Add debug component as the first step after trigger
        const debugPos = calculatePosition(1);
        //console.log("latest debug", debugComponent);
        updatedNodeDataArray.push({
            "category": "Comp",
            "loc": `-383.80000001192093 ${debugPos}`,
            "compId": debugComponent.compId,
            "masterComponentkey": debugComponent.masterComponentkey,
            "key": debugComponent.key,
            "name": debugComponent.name,
            "displayName": debugComponent.displayName,
            "source": debugComponent.source,
            "view": debugComponent.view,
            "data": debugComponent.data,
            "categoryname": debugComponent.categoryname,
            "categoryId": debugComponent.categoryId,
            "parent": debugComponent.parent,
            "selectable": false,
            "cursor": "default",
            "leftArray": [{ "portId": "left0" }, { "portId": "left1" }, { "portId": "left2" }, { "portId": "left3" }],
            "topArray": [{ "portId": "top0" }, { "portId": "top1" }, { "portId": "top2" }, { "portId": "top3" }],
            "bottomArray": [{ "portId": "bottom0" }, { "portId": "bottom1" }, { "portId": "bottom2" }, { "portId": "bottom3" }],
            "rightArray": [{ "portId": "right0" }, { "portId": "right1" }, { "portId": "right2" }, { "portId": "right3" }],
            "flowStepId": 2
        });

        // Add middle steps
        workflowSteps.forEach((step, index) => {
            const component = components.find(comp => comp.componentName === step.componentName);

            // Skip if component not found
            if (!component) {
                message.error(`Component data found: ${step.componentId}`);
                return;
            }

            updatedNodeDataArray.push({
                "category": "Comp",
                "loc": `-383.80000001192093 ${calculatePosition(index + 2)}`, // +2 because of trigger and debug
                "compId": component.componentId,
                "masterComponentkey": component.componentName,
                "key": component.componentId,
                "name": component.componentName,
                "displayName": component.displayName,
                "source": DOMAIN_PATH + component.componentIcon,
                "view": component.componentRoute,
                "data": component.config,
                "categoryname": component.categoryName,
                "categoryId": component.categoryId,
                "parent": component.categoryId,
                "selectable": false,
                "cursor": "default",
                "leftArray": [{ "portId": "left0" }, { "portId": "left1" }, { "portId": "left2" }, { "portId": "left3" }],
                "topArray": [{ "portId": "top0" }, { "portId": "top1" }, { "portId": "top2" }, { "portId": "top3" }],
                "bottomArray": [{ "portId": "bottom0" }, { "portId": "bottom1" }, { "portId": "bottom2" }, { "portId": "bottom3" }],
                "rightArray": [{ "portId": "right0" }, { "portId": "right1" }, { "portId": "right2" }, { "portId": "right3" }],
                "flowStepId": index + 4
            });
        });

        // Add the save step - make a deep copy to avoid reference issues
        updatedNodeDataArray.push({
            ...workflowData.nodeDataArray.find(node => node.name === "Save")
        });

        // Create updated linkDataArray
        const updatedLinkDataArray = [];

        // First link from Trigger to Debug component
        updatedLinkDataArray.push({
            "from": updatedNodeDataArray[0].key,
            "to": updatedNodeDataArray[1].key,
            "fromPort": "bottom1",
            "toPort": "top1",
            "text": "Output",
            "label": "Output",
            "points": [
                -393.30000001192093, calculatePosition(0) + 49,
                -393.30000001192093, calculatePosition(0) + 59,
                -393.30000001192093, calculatePosition(1) - 54,
                -392.30000001192093, calculatePosition(1) - 54,
                -392.30000001192093, calculatePosition(1) - 54,
                -392.30000001192093, calculatePosition(1) - 44
            ],
            "link-highlight-color": "transparent"
        });

        // Links between components
        for (let i = 1; i < updatedNodeDataArray.length - 1; i++) {
            const fromNode = updatedNodeDataArray[i];
            const toNode = updatedNodeDataArray[i + 1];

            // Parse data to get line text if possible
            let lineText = "Success";

            //debugger; // Remove this line in production
            //Default line text for Trigger component
            if (fromNode.name === "Trigger") {
                lineText = "Output";
            }

            if (fromNode.data) {
                try {
                    const dataObj = typeof fromNode.data === 'string' ? JSON.parse(fromNode.data) : fromNode.data;
                    if (dataObj?.loadJson?.configLines?.lines?.length > 0) {
                        lineText = dataObj.loadJson.configLines.lines[0].lineText || "Success";
                    }
                } catch (error) {
                    // Use default "Success" if parsing fails
                    console.log('Error parsing component data:', error);
                }
            }

            updatedLinkDataArray.push({
                "from": fromNode.key,
                "to": toNode.key,
                "fromPort": "bottom0",
                "toPort": "top1",
                "text": lineText,
                "label": lineText,
                "points": [
                    -409.30000001192093, calculatePosition(i) + 50,
                    -409.30000001192093, calculatePosition(i) + 60,
                    -409.30000001192093, (calculatePosition(i) + calculatePosition(i + 1)) / 2,
                    -394.30000001192093, (calculatePosition(i) + calculatePosition(i + 1)) / 2,
                    -394.30000001192093, calculatePosition(i + 1) - 17,
                    -394.30000001192093, calculatePosition(i + 1) - 7
                ],
                "link-highlight-color": "transparent"
            });
        }

        // Update the workflow data
        setWorkflowData({
            ...workflowData,
            nodeDataArray: updatedNodeDataArray,
            linkDataArray: updatedLinkDataArray
        });
    }, [workflowSteps, selectedComponent]);

    const handleComponentChange = (value) => {
        setSelectedComponent(value);
        const component = components.find(comp => comp.componentName === value);
        //setWorkflowSteps([...workflowSteps, component]);
        setWorkflowSteps([component]);
    }

    // Add a component to the workflow
    const createWorkflow = async () => {
        if (!selectedComponent) {
            message.error('Please select a component');
            return;
        }
        const dataFromDiagramjson = getDataFromDiagramJson(workflowData);
        //console.log("dataFromDiagramjson:", dataFromDiagramjson);

        await callSaveWorkflow(workflowName, workflowData, dataFromDiagramjson, selectedComponent);

        setSelectedComponent('');
    };

    const callSaveWorkflow = async (flowName, flowDiagram, updatedFlowData, compName) => {
        // Save the workflow data to the server or local storage
        const jsonData = {
            workflowId: 0,
            workFlowName: flowName || 'Debug ' + compName,
            workFlowDiagram: JSON.stringify(flowDiagram),
            workFlowData: JSON.stringify(updatedFlowData),
            workFlowCategoryId: config.WF_CATEGORY_TEST_COMONENT
        };

        console.log("Test flow jsonData:", jsonData);
        const response = await saveWorkflow(jsonData);
        const resData = response?.data;
        if (resData?.success) {
            var resError = "";
            if (resData?.businessRules[0]) {
                resError = "; Important: " + resData?.businessRules[0];
            }
            message.success('Workflow saved successfully' + resError);
        }
        else {
            let errMsg = "Process Failed: ";
            if (resData?.businessRules[0]) {
                errMsg += resData?.businessRules[0];
            }
            message.error(errMsg);
        }
    }

    // Remove a step from the workflow
    const removeStep = (index) => {
        const updatedSteps = [...workflowSteps];
        updatedSteps.splice(index, 1);
        setWorkflowSteps(updatedSteps);
    };

    return (
        <div style={{ padding: 20 }}>
            <Card title="Create workflow to test component" style={{ marginBottom: 20 }}>
                <Row gutter={16}>
                    <Col span={8}>
                        <label>Workflow Name</label>
                        <Input value={workflowName} onChange={e => setWorkflowName(e.target.value)} />
                    </Col>
                    <Col span={8}>
                        <label>Select Component</label>
                        <Select
                            style={{ width: '100%', marginBottom: 16 }}
                            placeholder="Select a component"
                            value={selectedComponent || ''}
                            onChange={handleComponentChange}
                        >
                            {components?.length > 0 ? (
                                components.map(comp => (
                                    <Select.Option key={comp.componentName} value={comp.componentName}>
                                        {comp.displayName}
                                    </Select.Option>
                                ))
                            ) : (
                                <Select.Option disabled key="no-data">
                                    No components available
                                </Select.Option>
                            )}
                        </Select>
                    </Col>
                    <Col span={8}>
                        <Button
                            type="primary"
                            style={{ marginTop: 24 }}
                            onClick={createWorkflow}
                        >
                            Create Workflow
                        </Button>
                    </Col>
                </Row>
            </Card>

            {/* <Card title="Workflow Steps" style={{ marginBottom: 20 }}>
                <div className="steps-container">
                    <div className="step-box">
                        <Card size="small" title="Trigger" style={{ backgroundColor: '#e6f7ff' }}>
                            Start
                        </Card>
                    </div>

                    <ArrowDownOutlined style={{ fontSize: 20, margin: '10px 0' }} />

                    <div className="step-box">
                        <Card size="small" title="DebugComponent" style={{ backgroundColor: '#f8f0ff' }}>
                            Debug Component (Fixed)
                        </Card>
                    </div>

                    {workflowSteps.map((step, index) => {
                        //const category = categories.find(cat => cat.id === step.categoryId);
                        //const categoryComponents = components[step.categoryId.toString()];
                        const component = components?.find(comp => comp.componentName === step.name);

                        return (
                            <div key={index} className="step-box">
                                <ArrowDownOutlined style={{ fontSize: 20, margin: '10px 0' }} />
                                <Card
                                    size="small"
                                    title={component?.displayName}
                                    style={{ backgroundColor: '#f6ffed' }}
                                    extra={
                                        <Button size="small" danger onClick={() => removeStep(index)}>
                                            Remove
                                        </Button>
                                    }
                                >
                                    <p>Category: {component?.categoryName}</p>
                                    <p>Component: {component?.componentName}</p>
                                </Card>
                            </div>
                        );
                    })}

                    <ArrowDownOutlined style={{ fontSize: 20, margin: '10px 0' }} />

                    <div className="step-box">
                        <Card size="small" title="Save" style={{ backgroundColor: '#fff1f0' }}>
                            End
                        </Card>
                    </div>
                </div>
            </Card> */}

            {/* <Card title="Generated JSON">
                <Button
                    type="primary"
                    onClick={() => {
                        navigator.clipboard.writeText(JSON.stringify(workflowData, null, 2));
                        message.success('JSON copied to clipboard');
                    }}
                    style={{ marginBottom: 16 }}
                >
                    Copy JSON
                </Button>
                <Input.TextArea
                    value={JSON.stringify(workflowData, null, 2)}
                    autoSize={{ minRows: 10, maxRows: 20 }}
                    readOnly
                />
            </Card> */}

            <style>{`
                .steps-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .step-box {
                    width: 100%;
                    max-width: 400px;
                    margin-bottom: 5px;
                }
            `}</style>
        </div>
    );
};

export default WorkflowEditor;